const HttpStatus = {
  SUCCESS: 200,
  UNAUTHORIZED: 401,
};

export {HttpStatus};